export default "__VITE_ASSET__D8uz_StU__"